// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1wvZr","inputWrap":"CustomTip_inputWrap__1RlW2"};